
define(
	'MHI.BasicEnhancements.CheckoutEntryPoints'
,   [
		
	]
,   function (
		
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			

		}
	};
});
